export const WHATSAPP_URL = "https://api.whatsapp.com/send?text=";
